import React from 'react';
import {Platform, View} from 'react-native';
import Screen from '../../../../shared/components/screen';
import {useStyles} from '../../../../shared/hooks/styles';
import {Routes, Screens} from '../../../../shared/routing';
import {Breadcrumbs} from '../../../../shared/components/breadcrumbs';
import {Button} from '../../../../shared/components/button';
import {images} from '../../../../assets/icons';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {RequestsTable} from './components/topicTable';
import {Props} from './model';
import {Text} from '../../../../shared/components/text';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {CustomScrollView} from '../../../../shared/components/scrollView';

const routes = [
  {
    title: 'Служба поддержки',
    routeName: Screens.SupportService,
    webRoute: Routes.supportService,
  },
  {
    title: 'Мои обращения',
    routeName: Screens.SupportServiceTopics,
    webRoute: Routes.supportServiceTopics,
  },
];

export default ({requests, showMore, allShown, onPressTopicCreate}: Props) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles(({theme, mediaOnly}) => ({
    sectionContainer: {
      marginTop: deviceSize === DeviceSize.desktop ? 21 : 0,
      marginHorizontal: deviceSize === DeviceSize.desktop ? 60 : 0,
      marginBottom: theme.screen.bottomOffset,
    },
    sectionTitle: theme.fonts.h2,
    cont: {
      marginTop: deviceSize === DeviceSize.desktop ? 42 : 0,
      marginHorizontal: deviceSize === DeviceSize.desktop ? 0 : 30,
      alignSelf: 'stretch',
    },

    addButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    textButton: {
      ...theme.fonts.h6Light,
    },
    topicsTitleContainer: {display: 'flex', flexDirection: 'row', justifyContent: 'space-between'},
    addButtonCont: {minWidth: 220, width: 'auto', marginRight: 0, paddingVertical: 4},
    notificationTableContainer: {marginTop: deviceSize === DeviceSize.desktop ? 34 : 28},
    showAllButtonContainer: {display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 30},
    addButton: {width: 203},
    noTopicsText: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
      color: theme.color.labelText,
      textAlign: deviceSize === DeviceSize.desktop ? 'left' : 'center',
    },
  }));

  const showMoreButtonVisible = !allShown && Platform.OS === 'web';

  return (
    <Screen>
      <CustomScrollView
        contentInsetAdjustmentBehavior='automatic'
        onEndReached={!allShown && Platform.OS !== 'web' ? showMore : undefined}>
        <View style={styles.sectionContainer}>
          <Breadcrumbs routes={routes} />
          <View style={styles.cont}>
            {deviceSize === DeviceSize.desktop ? (
              <View style={styles.topicsTitleContainer}>
                <Text testID='my-requests-title-id' style={styles.sectionTitle}>
                  Мои обращения
                </Text>
                <Button
                  id='topics-new'
                  onPress={onPressTopicCreate}
                  style={styles.addButtonCont}
                  type='primary'
                  iconPosition='left'
                  icon={images.Plus}
                  iconProps={{width: 20, height: 20}}
                  iconStyles={{marginRight: 4}}
                  textStyle={styles.textButton}
                  text='Новое обращение'
                />
              </View>
            ) : null}
            <View style={styles.notificationTableContainer}>
              <LoadableContent loading={!requests}>
                {requests ? (
                  requests.length ? (
                    <RequestsTable requests={requests} />
                  ) : (
                    <Text style={styles.noTopicsText}>У вас пока нет обращений</Text>
                  )
                ) : null}
              </LoadableContent>
            </View>
            {showMoreButtonVisible ? (
              <View style={styles.showAllButtonContainer}>
                <Button
                  id='topics-more'
                  style={styles.addButton}
                  onPress={() => showMore()}
                  type='secondary'
                  text='Показать ещё'
                />
              </View>
            ) : null}
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
